import {cn, RsnAmountInput, RsnButton} from '@raison/ui-kit';
import React, {ComponentProps, Fragment, ReactNode} from 'react';
import {Slot} from '~/shared/utils/types';
import styles from './FiatOperationLayout/FiatOperationLayout.module.scss';

interface FiatOperationLayoutProps {
    onSubmit?: React.FormEventHandler<HTMLFormElement>;
    submitActionTitle: string;
    submitPreviewEntries: [Slot, Slot][];
    inputHint?: string | undefined;
    hintAction?: ReactNode | undefined;
    optionsAboveForm?: Record<string, Slot>;
    operationSettings?: Slot;
    optionsBelowForm?: Record<string, Slot>;
    formAttributes?: React.ComponentProps<'form'>;
    inputOptions: ComponentProps<typeof RsnAmountInput>;
    isLoading?: boolean;
}

const FiatOperationLayout: React.FC<FiatOperationLayoutProps> = props => {
    const {
        submitActionTitle,
        submitPreviewEntries,
        optionsAboveForm,
        operationSettings,
        optionsBelowForm,
        formAttributes,
        inputOptions,
        inputHint,
        hintAction,
        onSubmit,
        isLoading,
    } = props;

    const formId = 'operation-form';

    return (
        <div className={styles.container}>
            {optionsAboveForm && renderOptions(optionsAboveForm)}
            {operationSettings}

            <form
                className={styles.form}
                id={formId}
                {...formAttributes}
                onSubmit={e => {
                    e.preventDefault();
                    if (!onSubmit?.(e)) {
                        formAttributes?.onSubmit?.(e);
                    }
                }}
            >
                <RsnAmountInput {...inputOptions} hintAction={hintAction} helperText={inputHint} />
            </form>

            {optionsBelowForm && renderOptions(optionsBelowForm)}

            <div>
                {renderSubmitPreview(submitPreviewEntries)}
                <RsnButton.Primary className={styles.submitButton} disabled={isLoading} type='submit' form={formId}>
                    {submitActionTitle}
                </RsnButton.Primary>
            </div>
        </div>
    );
};

export default FiatOperationLayout;

export const renderOptions = (options: Record<string, Slot>) =>
    Object.entries(options).map(([label, option], i) => (
        <div key={i}>
            <p className={styles.optionPickerLabel}>{label}</p>
            {option}
        </div>
    ));

export const renderSubmitPreview = (entries: [Slot, Slot][], accent = false) => (
    <div className={styles.submitPreview}>
        {entries.map(([label, value], i) => (
            <Fragment key={i}>
                <div>{label}</div>
                <div className={cn({[styles.accent]: accent})}>{value}</div>
            </Fragment>
        ))}
    </div>
);
